export const QueryStringKeys = {
  contactId: 'cID',
  supporterId: 'sid',
};

export const LeadFormFirstNameMaxLength = 40;
export const LeadFormLastNameMaxLength = 80;
export const LeadFormChurchNameMaxLength = 40;
export const LeadFormChurchCityMaxLength = 40;
